export const isMac = () => !!navigator.platform?.toLowerCase().includes('mac');
